const en_US = {
    local: 'en_US',
    app_name: 'Chess Alliance',
    app_title: 'Chess Alliance - Professional Chess App',
    app_describe: 'Chess Alliance is a professional platform with extensive features designed to help chess players all around the world to play, practice, learn and improve on their chess levels. More than half a million players on Chess Alliance are already studying in chess clubs. Come and join us! Have fun and make friends with players at all levels and in any age group!',
    txt_scan_download: 'Scan to Download',
    txt_app_screenshots: 'Screenshots',
    app_icp_copyright: 'ICP No.15045948 Copyright © 2015-' + new Date().getFullYear() + ' Beijing Chessease Co., Ltd.',
    app_icp: 'ICP No.15045948',
    app_copyright: 'Copyright © 2015-' + new Date().getFullYear() + '  Beijing Chessease Co., Ltd.',
    txt_open_in_browser: 'Click on the menu to open in browser',
    txt_error: 'An unknown error has occurred',
    btn_error: 'Home Page',
    app_invite: 'Chess Alliance - Professional Chess App!\nLogin Chess Alliance and enter this invitation code to get 10 coins for yourself and 5 coins for your friend!',
    txt_invite: 'Invitation Code - ',
    btn_board_turn: 'Flip Board',
    btn_pgn_view: 'PGN',
    btn_pgn_download: 'Download PGN',
    btn_app_download: 'Download App',
    btn_download: 'Download',
    btn_close: 'Close',
    puzzle_white_first: 'White to move',
    puzzle_black_first: 'Black to move',
    puzzle_solve_success: 'Solved',
    puzzle_solve_warn: 'Have Better Move',
    puzzle_solve_error: 'Try again',
    pc_mumu: 'PC（MUMU模拟器专版）',
};
export default en_US;


// WEBPACK FOOTER //
// ./src/en_US.js